import { getText } from "shared/lib";
import { type TreeDescriptor } from "@/components/treeModule/lib";

import { Dialog, DialogContent, DialogTitle } from "shared/components";
import { SingleStemDiameterContent } from "@/components/treeModule/treeMeasurementsHelp/SingleStemDiameterContent";

export interface SingleStemDiameterDialogProps {
  onOpenChange: (open: boolean) => void;
  open: boolean;
  treeDescriptor: TreeDescriptor | undefined | null;
}

export function SingleStemDiameterDialog({
  onOpenChange,
  open,
  treeDescriptor,
}: SingleStemDiameterDialogProps) {
  return (
    <Dialog onOpenChange={onOpenChange} open={open}>
      <DialogContent className="max-h-[95vh] !max-w-[600px] overflow-auto">
        <DialogTitle>
          {getText("How to measure a single stem tree")}
        </DialogTitle>

        <SingleStemDiameterContent treeDescriptor={treeDescriptor} />
      </DialogContent>
    </Dialog>
  );
}
